import React from "react";
import { motion } from "framer-motion";

import heroIcon1 from "../Images/hero-icon-1.png";
import heroIcon2 from "../Images/hero-icon-2.png";
import heroIcon3 from "../Images/hero-icon-3.png";

const Hero = () => {

  // MAIN CONTAINER
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.18,
      },
    },
  };

  // PREMIUM FADE UP
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // FEATURE CARD
  const featureVariant = {
    hidden: {
      opacity: 0,
      y: 35,
      scale: 0.96,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.85,
        delay: i * 0.12,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <section className="hero-section">

      {/* OVERLAY */}
      <motion.div
        className="hero-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: 1.4,
          ease: "easeOut",
        }}
      />

      <div className="container hero-container">

        {/* LEFT */}
        <motion.div
          className="hero-left"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >

          {/* SUBTITLE */}
          <motion.p
            className="hero-subtitle"
            variants={fadeUp}
          >
            PROPERTY SETTLEMENTS MADE SIMPLE
          </motion.p>

          {/* TITLE */}
          <motion.h1
            className="hero-title"
            variants={fadeUp}
          >
            Perth Settlement <br />
            Agents You Can Rely On
          </motion.h1>

          {/* DESCRIPTION */}
          <motion.p
            className="hero-desc"
            variants={fadeUp}
          >
            Expert settlement services for residential and
            commercial properties across Perth & WA.
            We make your property journey smooth,
            secure and stress-free.
          </motion.p>

          {/* FEATURES */}
          <motion.div
            className="hero-features"
            variants={fadeUp}
          >

            <motion.div
              className="hero-feature"
              custom={0}
              variants={featureVariant}
              whileHover={{
                y: -6,
                transition: {
                  duration: 0.35,
                },
              }}
            >

              <motion.img
                src={heroIcon1}
                alt="Secure Tranactions | LDL Settlement Services"
                whileHover={{
                  scale: 1.08,
                  rotate: -2,
                }}
                transition={{
                  duration: 0.4,
                }}
              />

              <span>
                Secure <br />
                Transactions
              </span>

            </motion.div>

            <motion.div
              className="hero-feature"
              custom={1}
              variants={featureVariant}
              whileHover={{
                y: -6,
                transition: {
                  duration: 0.35,
                },
              }}
            >

              <motion.img
                src={heroIcon2}
                alt="Experiences Professionals | LDL Settlement Services"
                whileHover={{
                  scale: 1.08,
                  rotate: -2,
                }}
                transition={{
                  duration: 0.4,
                }}
              />

              <span>
                Experienced <br />
                Professionals
              </span>

            </motion.div>

            <motion.div
              className="hero-feature no-border"
              custom={2}
              variants={featureVariant}
              whileHover={{
                y: -6,
                transition: {
                  duration: 0.35,
                },
              }}
            >

              <motion.img
                src={heroIcon3}
                alt="Efficient Settlements | LDL Settlement Services"
                whileHover={{
                  scale: 1.08,
                  rotate: -2,
                }}
                transition={{
                  duration: 0.4,
                }}
              />

              <span>
                Efficient <br />
                Settlements
              </span>

            </motion.div>

          </motion.div>

          {/* BUTTONS */}
          <motion.div
            className="hero-btns"
            variants={fadeUp}
          >

            <motion.a
            href="/get-a-quote"
              className="primary-btn"
              whileHover={{
                y: -4,
                scale: 1.03,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              Get a Quote
            </motion.a>

            <motion.a
            href="/contact-us"
              className="secondary-btn"
              whileHover={{
                y: -4,
                scale: 1.03,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              Contact us
            </motion.a>

          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default Hero;